import React, { useState } from "react";
import { useNavigate } from "react-router";
import { HStack, VStack } from "../../../components/utils";
import BCHeader from "../../../shared/BCHeader";
import AllocationMatrixStepper from "./AllocationMatrixStepper";
import AllocationMatrixDetailsNavigation from "./AllocationMatrixDetailsNavigation";
import { useAllocationMatrixStore } from "../../../store/useAllocationMatrixStore";

const AllocationMatrixContainer = () => {
  const navigate = useNavigate();
  const data = useAllocationMatrixStore();
  const [currentStep, setCurrentStep] = useState(data.matrixId ? 3 : 1);

  const readOnly = data.isReadOnly;

  function onStepChange(step?: number) {
    setCurrentStep(step || parseInt(`${currentStep}`, 10) + 1);
  }

  function onBackClick() {
    if (currentStep !== 1) {
      setCurrentStep(parseInt(`${currentStep}`, 10) - 1);
    } else {
      data.clear();
      navigate("/settings/companyProfile", {
        state: { tab: "Allocation Matrix" },
      });
    }
  }

  return (
    <VStack className="h-full gap-4">
      <div className="flex items-baseline justify-between">
        <BCHeader
          bcTitle="Allocation Matrix Details"
          className="py-1"
          bcSubTitle={
            readOnly ? "View Allocation Matrix" : "Create Allocation Matrix"
          }
          onClick={() => {
            data.clear();
            navigate("/settings/companyProfile", {
              state: { tab: "Allocation Matrix" },
            });
          }}
        />
      </div>
      <HStack className="flex h-full min-h-full gap-4">
        <VStack className="flex w-[18%] bg-white rounded-md min-w-52">
          <AllocationMatrixStepper
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        </VStack>
        <VStack className="flex w-[82%] bg-white rounded-md min-w-96">
          <AllocationMatrixDetailsNavigation
            currentStep={currentStep}
            onStepChange={onStepChange}
            onBackClick={onBackClick}
            readOnly={readOnly}
          />
        </VStack>
      </HStack>
    </VStack>
  );
};

export default AllocationMatrixContainer;
